/**
 * Human-readable file size ("0 Bytes", "1.5 KB", "2.25 MB"), rounded to at
 * most `digits` decimals with trailing zeros dropped.
 */
export const formatFileSize = (bytes: number, digits = 1): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(digits)) + ' ' + sizes[i];
};
